import { useAuthLibContext as l } from "../contexts/AuthLibContext.js";
import { downloadInfoSchema as u } from "../../download-lib/deserializes/yup/download.js";
import { ERROR_CODE as d } from "../../temp-lib/constants/error.js";
import { CustomError as p } from "../../temp-lib/errors/customError.js";
import h from "../../temp-lib/hooks/json/useFetchJson.js";
import w from "../../temp-lib/hooks/json/useReactQueryFetchJson.js";
import * as t from "ramda";
import { useCallback as g, useMemo as R } from "react";
const F = (M) => {
  const { config: e } = l(), { fetchNow: c } = {}, i = g(() => {
    const { fetchJson: o } = e;
    if (t.isNil(o))
      throw new p(
        'config "fetchJson" is not defined',
        d.GENERAL.MISSING_CONFIG
      );
    return [o.buildURL, o.downloadPath];
  }, [e]), [f, a] = R(() => i(), [i]), { fetchJson: s } = h({
    url: f
  });
  return w({
    fetchNow: c,
    key: `auth-${a}`,
    path: a,
    deserialize: async (o) => {
      const m = await s(), n = (r) => u.cast(r, {
        context: {
          data: r,
          info: t.propOr({}, "client_version", m)
        }
      });
      return {
        battleDemo: t.map(n, o.battleDemo || []),
        login: t.map(n, o.login || []),
        officialSite: t.map(n, o.officialSite || []),
        foonieMagus: t.map(n, o.foonieMagus || [])
      };
    }
  });
};
export {
  F as default
};
//# sourceMappingURL=useFetchDownloadMap.js.map
